module.exports = __webpack_public_path__ + "img/15.9e7f4f3f.svg";